export const ABOUT_YOUR_DOGS: Record<AboutYourDogsScreenNames, string> = {
	AYD_NOD_INTRO: /*html*/ `
            <div>
            <h5>Routing</h5>
            <table>
                <thead>
                <tr>
                    <th>Option(s)</th>
                    <th>Next Route</th>
                    <th>Next Screen</th>
                </tr>
                </thead>
                <tr>
                <td>"N/A</td>
                <td>THOUGHTS_ON_DOGS</td>
                <td>E1</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p><strong>INTRO</strong></p>
            <p>Cold intro to the survey</p>
            </div>
        `,

	Q1: /*html*/ `
            <div>
            <h5>Routing</h5>
            <table>
                <thead>
                <tr>
                    <th>Option(s)</th>
                    <th>Next Route</th>
                    <th>Next Screen</th>
                </tr>
                </thead>
                <tr>
                <td>"I don't have a dog"</td>
                <td>THOUGHTS_ON_DOGS</td>
                <td>TOD_INTRO</td>
                </tr>
                <tr>
                <td>All other options</td>
                <td>ABOUT_YOUR_DOGS</td>
                <td>AYD_INTRO</td>
                </tr>
            </table>
            <h5>Other info</h5>
            <p>Five or more will display a number input</p>
            </div>
        `,

	AYD_INTRO: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>All options</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q2</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p>Will display "dog" in title if one dog or "dogs" if multiple</p>
        </div>
    `,

	Q2: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>All options</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q3</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>MANDATORY - HAS A TOOLTIP</strong></p>
        <p>Will display display an input for each of the user's dogs up to 5</p>
        <p>Selecting "Prefer not to say" will auto-fill and disable inputs</p>
        <p>If "Prefer not to say" is selected, we submit that but show a friendly name like "Your most recent" or "your second most recent" etc</p>
        </div>
    `,

	Q3: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>All options</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q4</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>OPTIONAL</strong></p>
        </div>
    `,

	Q4: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>All options</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q5</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>OPTIONAL</strong></p>
        </div>
    `,

	Q5: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>All options</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q6</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>OPTIONAL</strong></p>
        </div>
    `,

	Q6: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>A pure breed</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q6_1</td>
            </tr>
            <tr>
            <td>A cross breed</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q6_2</td>
            </tr>
            <tr>
            <td>Unknown mix</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q6_3</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>MANDATORY</strong></p>
        </div>
    `,

	Q6_1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>Specific breed</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q7</td>
            </tr>
            <tr>
            <td>Unknown/Prefer not to say/Not listed/ No answer</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q6_3</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>OPTIONAL</strong></p>
        <p>Selecting "Not listed" will show a text field</p>
        </div>
    `,

	Q6_2: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>All options</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q6_3</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>OPTIONAL</strong></p>
        <p>Selecting "Not listed" on either field will show a text field</p>
        </div>
    `,

	Q6_3: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>All options</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q7</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>OPTIONAL</strong></p>
        </div>
    `,

	Q7: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>None of the above / none selected</td>
            <td>CHOOSING_YOUR_DOG</td>
            <td>CYD_INTRO</td>
            </tr>
            <tr>
            <td>All other options</td>
            <td>ABOUT_YOUR_DOGS</td>
            <td>Q7_1</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>OPTIONAL</strong></p>
        <p>"None of the above" is exclusive</p>
        </div>
    `,

	Q7_1: /*html*/ `
        <div>
        <h5>Routing</h5>
        <table>
            <thead>
            <tr>
                <th>Option(s)</th>
                <th>Next Route</th>
                <th>Next Screen</th>
            </tr>
            </thead>
            <tr>
            <td>All options</td>
            <td>CHOOSING_YOUR_DOG</td>
            <td>CYD_INTRO</td>
            </tr>
        </table>
        <h5>Other info</h5>
        <p><strong>OPTIONAL</strong></p>
        <p>There will be one radiogroup for each of the valid options selected on Q7</p>
        </div>
    `,
};
